import React from 'react';
import PropTypes from 'prop-types';
import ReactToPrint from 'react-to-print';
import { FormattedMessage } from 'react-intl';

import styles from './panel.module.scss';


const Panel = ({ containerClasses, title, defaultTitle, children, translationValues, display, fromGate,
   comments, onCommentStatus, contentClasses, adpHistory, handelHistory, adpComments, handleComments,
   viewReceipts, printRef, selectedInvoice, applicationDetails, profile }) => (
  <div className={`${styles.panel} ${containerClasses}`}>
    <div className={`${styles.title} ${styles.heading}`}>
      <FormattedMessage
        id={title}
        defaultMessage={defaultTitle}
        values={translationValues}
      /> <span> {display} </span>
      {
        <div>
          {viewReceipts && typeof viewReceipts === 'function' && (
            <button className={styles.comment} onClick={() => viewReceipts(true)}>
              <FormattedMessage
                id="workorders.detail.receipts"
                defaultMessage="View Receipt(s)"
              />
              <ReactToPrint
                trigger={() => (
                  <button
                    type="button"
                    style={{ display: 'none' }}
                    ref={(el) => { window.printTrigger = el; }}
                  >
                    Print Hidden
                  </button>
                )}
                content={() => printRef.current}
                documentTitle={`${profile?.portal_airport?.name} (${profile?.portal_airport?.code})`}
              />
              {/* Hidden print container */}
              <div style={{ display: 'none' }}>
                <div ref={printRef}>
                  {selectedInvoice && (
                    <span
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        // eslint-disable-next-line no-eval
                        __html: eval(
                          `\`${applicationDetails?.settings?.custom_invoice_template}\``
                        )
                      }}
                    />
                  )}
                </div>
              </div>
            </button>
          )}
          {adpComments && (
            <button className={styles.comment} onClick={() => { handleComments(); }}>
              Comments
            </button>
          )}
          {adpHistory
          ? (
            <button className={`${styles.comment} ${styles.marginRight}`}
            onClick={() => { handelHistory(); }}
            >
              <FormattedMessage
                id=" "
                defaultMessage={adpHistory}
              />
            </button>
          )
          : null
          }
        </div>
      }
      {
        comments
        ? <button className={styles.comment} onClick={() => { onCommentStatus(); }}>All Comments ({comments.length})</button>
        : null
      }
    </div>
    <div className={`${styles.content} ${contentClasses}`} style={{ alignItems: fromGate?'normal':'center' }}>
      {children}
    </div>
  </div>
);

Panel.defaultProps = {
  containerClasses: '',
  translationValues: {}
};

Panel.propTypes = {
  containerClasses: PropTypes.string,
  title: PropTypes.string.isRequired,
  defaultTitle: PropTypes.string.isRequired,
  translationValues: PropTypes.shape({}),
  children: PropTypes.node.isRequired
};
export default Panel;
